import { Box, CircularProgress } from '@mui/material'

export function FullPageSpinner() {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', pt: 20 }}>
      <CircularProgress size={120} />
    </Box>
  )
}
